module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium.eb2e6615.ttf";